module.exports = __webpack_public_path__ + "img/Feature.a4da7fe2.png";